import React, { useState, useEffect, useRef, Suspense } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useNavigate, Navigate, Link, useLocation } from "react-router-dom";
import * as constantMessages from "../../constants/constatntMessages";
import { Button, Popover, OverlayTrigger, Tooltip } from "react-bootstrap";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { useSelector, useDispatch } from "react-redux";
import Badge from "react-bootstrap/Badge";
import "./style/meetings-css.css";
import {
  fetchMeetingList,
  processCancelMeeting,
  processCloseMeeting,
  updateRsvp,
  updateRsvpByEmail,
  viewMeetingStatistics,
  processdeleteMeeting,
  fetchMeetingListForReschedule,
  setCreatedByIdForMeeting,
} from "../../redux/actions/meetingActions/MeetingAction";
import Loader from "../Common/Loader";
import Alert from "../Common/Alert";
import MeetingDropDown from "./MeetingDropDown";
import AttendeesModal from "./AttendeesModal";
import { customName, getColorFromId } from "../../helpers/commonHelpers";
import NoDataFound from "../Common/NoDataFound";
import AttendeesRsvpModal from "./AttendeesRsvpModal";
import CommonModal from "../Common/CommonModal";
import CancelMeetingModal from "./CancelMeetingModal";
import { logOut } from "../../redux/actions/authActions/authAction";
import RescheduleMeetingModal from "./RescheduleMeetingModal";
import Footer from "../Common/Footer/Footer";
import ResendMeetingDetailsModal from "./ResendMeetingDetailsModal";
import MeetingDetailsPieChart from "./MeetingDetailsPieChart";
import AddButton from "../Common/AddButton";
import DeleteMeetingModal from "./DeleteMeetingModal";
import TableSortLabel from "@mui/material/TableSortLabel";
const FilterComponent = React.lazy(() => import("./FilterComponent"));
const regularExpressionForSearch =
  /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}()\[\]]+$/;
const MeetingList = React.memo(() => {
  const location = useLocation();
  const { paramDatas } = location.state || {};
  const userData = JSON.parse(localStorage.getItem("userData"));
  const accessToken = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const meetingData = useSelector((state) => state.meeting);
  const loginUserData = useSelector((state) => state.user);
  const employeeData = useSelector((state) => state.user);
  const [orderBy, setOrderBy] = useState(["date", "title", "status"]);
  const [order, setOrder] = useState("asc"); // or "desc"
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const [showUserData, setShowUserData] = useState(false);
  const [filter, setfilter] = useState(false);
  const [errors, setErrors] = useState({});
  const [meetingId, setMeetingId] = useState(null);

  const [createdById, setCreatedById] = useState(null);
  const [rsvpCount, setRsvpCount] = useState("");
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const [isRsvpModalOpen, setIsRsvpModalOpen] = useState(false);
  const [isResendMeetingDetailsModalOpen, setIsResendMeetingDetailsModalOpen] =
    useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [attendeesData, setAttendeesData] = useState([]);
  const [meetingDetails, setMeetingDetails] = useState(null);
  const [singleMeetingDetails, setSingleMeetingDetails] = useState(null);
  const [searchData, setSearchData] = useState({
    searchKey: "",
    page: 1,
    limit: 5,
    order: -1,
    filterData: {},
  });
  const [success, setSuccess] = useState(false);
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(query);
  const prevDebouncedRef = useRef(debouncedQuery);

  const [screenSize, setScreenSize] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call on initial render if needed
    handleResize();

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Debounce effect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query); // Triggers only after delay
    }, 800); // 800ms delay

    return () => {
      clearTimeout(handler); // Cleanup on input change
    };
  }, [query]);

  useEffect(() => {
    if (debouncedQuery || (prevDebouncedRef.current && debouncedQuery === "")) {
      setSearchData((prev) => ({ ...prev, page: 1 }));
      fetchMeetings(debouncedQuery);
      prevDebouncedRef.current = debouncedQuery;
    }
  }, [debouncedQuery]);

  useEffect(() => {
    const sendRsvp = async () => {
      if (paramDatas?.meetingId && paramDatas?.userId && paramDatas?.rsvp) {
        const result = await dispatch(updateRsvpByEmail(paramDatas));
        if (result?.success) {
          navigate(location.pathname, { replace: true, state: undefined });
        }
      }
    };
    sendRsvp();
  }, []);

  useEffect(() => {
    setSuccess(!success);
  }, [meetingData?.isSuccess]);

  useEffect(() => {
    if (accessToken && userData) {
      fetchMeetings(query);
    }
  }, [
    searchData.order,
    searchData.page,
    searchData.limit,
    searchData.filterData,
    searchData.searchKey,
    meetingData.isRsvpUpdated,
    authData.isInValidUser,
  ]);

  useEffect(() => {
    if (!accessToken || !userData) {
      navigate("/login");
    } else {
      fetchMeetings(query);
    }
    document.title = "Meeting List: MinutesVault";
  }, []);

  const fetchMeetings = (overrideSearchKey) => {
    const payload = {
      page: searchData.page,
      order: searchData.order,
      limit: searchData.limit,
      organizationId: userData.organizationId,
      meetingStatus: searchData.filterData?.meetingStatus,
      meetingType: searchData.filterData?.meetingType,
      toDate: searchData.filterData?.toDate,
      fromDate: searchData.filterData?.fromDate,
      attendeeId: searchData.filterData?.attendeeId,
      createdById: createdById,
      accessToken,
    };

    const key = overrideSearchKey ?? searchData.searchKey;
    if (key?.trim()) {
      if (!regularExpressionForSearch.test(key)) {
        setErrors({ searchKey: constantMessages.titleRegexError });
        return;
      }
      payload.searchKey = key;
    }

    setErrors({});
    dispatch(fetchMeetingList(payload));
  };
  const fetchMeetingListForRescheduleData = (overrideSearchKey) => {
    const payload = {
      page: searchData.page,
      order: searchData.order,
      limit: searchData.limit,
      organizationId: userData.organizationId,
      meetingStatus: searchData.filterData?.meetingStatus,
      meetingType: searchData.filterData?.meetingType,
      toDate: searchData.filterData?.toDate,
      fromDate: searchData.filterData?.fromDate,
      attendeeId: searchData.filterData?.attendeeId,
      accessToken,
    };

    const key = overrideSearchKey ?? searchData.searchKey;

    if (key?.trim()) {
      if (!regularExpressionForSearch.test(key)) {
        setErrors({ searchKey: constantMessages.titleRegexError });
        return;
      }
      payload.searchKey = key;
    }

    setErrors({});
    dispatch(fetchMeetingListForReschedule(payload));
  };

  const filterData = (data) => {
    setSearchData({
      ...searchData,
      filterData: data,
      page: 1,
    });
  };

  const setModalStatus = (value, meeting) => {
    if (meeting?.attendees?.length !== 0) {
      setIsModalOpen(value);
      setAttendeesData([...meeting?.attendees]);
      setMeetingDetails(meeting);
    }
  };
  const setRsvpModalStatus = (value, attendeesData, rsvpCount) => {
    setIsRsvpModalOpen(value);
    setAttendeesData([...attendeesData]);
    setRsvpCount(rsvpCount);
  };

  useEffect(() => {
    if (!authData.isInValidUser) {
      dispatch(viewMeetingStatistics(userData?.organizationId, accessToken));
    }
  }, [meetingData.isFetchedMeetingList, authData.isInValidUser]);

  const handleDeleteModal = (meetingId) => {
    setMeetingId(meetingId);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteMeeting = async () => {
    if (!authData.isInValidUser) {
      setIsLoading(true);
      const result = await dispatch(
        processdeleteMeeting(meetingId, accessToken)
      );
      setIsLoading(false);
      if (result?.status) {
        fetchMeetings();
        setMeetingId(null);
        setIsDeleteModalOpen(false);
      }
    }
  };

  const closeMomPermissionModalClose = async () => {
    fetchMeetings();
  };

  ///////////////////////////

  const handleCancelMeeting = async (remarks) => {
    if (!authData.isInValidUser) {
      setIsLoading(true);
      const result = await dispatch(
        processCancelMeeting(meetingId, { remarks }, accessToken)
      );
      setIsLoading(false);

      if (result?.status) {
        fetchMeetings();
        setMeetingId(null);
        setIsCancelModalOpen(false);
      }
    }
  };

  const handleCloseMeeting = () => {
    if (!authData.isInValidUser) {
      dispatch(
        processCloseMeeting(meetingId, { meetingStatus: "closed" }, accessToken)
      );
    }
    setMeetingId(null);
    setIsCloseModalOpen(false);
  };
  const handleCancelModal = (meetingId) => {
    setMeetingId(meetingId);
    setIsCancelModalOpen(true);
  };

  const handleCloseModal = (meetingId) => {
    setMeetingId(meetingId);
    setIsCloseModalOpen(true);
  };

  const handleRescheduleModal = (singleMeetingDetails) => {
    setSingleMeetingDetails(singleMeetingDetails);

    setIsRescheduleModalOpen(true);
  };
  const handleResendMeetingDetailsModal = (singleMeetingDetails) => {
    setSingleMeetingDetails(singleMeetingDetails);

    setIsResendMeetingDetailsModalOpen(true);
  };

  const handlePageChange = (event, value) => {
    setSearchData((prev) => ({
      ...prev,
      page: value,
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setQuery(value);
    setSearchData({
      ...searchData,
      [name]: value,
    });
  };

  const totalOption =
    meetingData?.totalCount && meetingData?.totalCount % 5 === 0
      ? Math.round(meetingData.totalCount / 5)
      : meetingData?.totalCount && meetingData?.totalCount % 5 !== 0
        ? Math.round(meetingData.totalCount / 5 + 0.5)
        : 0;
  const checkTotalPage =
    meetingData.totalCount % searchData.limit === 0
      ? Math.round(meetingData.totalCount / searchData.limit)
      : Math.round(meetingData.totalCount / searchData.limit + 0.5);
  const totalPage = meetingData.totalCount ? checkTotalPage : 0;
  const totalPageArray = Array(totalPage).fill();

  let modifiedArray = [];
  totalPageArray.map((item, index) => {
    if (
      index === searchData.page - 1 ||
      (index <= searchData.page + 3 && index >= searchData.page)
    ) {
      modifiedArray.push(index);
    }
    return item;
  });
  const fromDataCount =
    meetingData.meetingList?.length === 0
      ? 0
      : (searchData.page - 1) * searchData.limit + 1;
  const toDataCount =
    (searchData.page - 1) * searchData.limit + meetingData.meetingList?.length;
  const totalCount = meetingData.totalCount;

  const checkRsvpCount = (attendees) => {
    let yesCount = 0;
    let noCount = 0;
    let pendingCount = 0;
    let mayBeCount = 0;

    attendees.map((item) => {
      item.rsvp === "YES"
        ? (yesCount = yesCount + 1)
        : item.rsvp === "NO"
          ? (noCount = noCount + 1)
          : item.rsvp === "MAYBE"
            ? (mayBeCount = mayBeCount + 1)
            : (pendingCount = pendingCount + 1);
    });

    const countMessage = `${yesCount} Yes, ${noCount} No, ${mayBeCount} May Be, ${pendingCount} Awaiting`;
    return countMessage;
  };

  const popoverHoverFocus = (title) => {
    return (
      <Popover id="popover-basic" className="custom-popover">
        <Popover.Body className="popover-body">{title}</Popover.Body>
      </Popover>
    );
  };
  const tooltip = (attendee) => {
    return (
      <Tooltip id="tooltip">
        {attendee.name} / {attendee?.email}
      </Tooltip>
    );
  };

  const STATUS_RANK = {
    draft: 1,
    scheduled: 2,
    rescheduled: 3,
    closed: 4,
    cancelled: 5,
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";

    setOrder(newOrder);
    setOrderBy(property);
  };

  const sortedMeetings = [...(meetingData?.meetingList || [])].sort((a, b) => {
    let aVal = a[orderBy];
    let bVal = b[orderBy];

    switch (orderBy) {
      case "status": {
        aVal =
          STATUS_RANK[(a?.meetingStatus?.status || "").toLowerCase()] ?? 999;
        bVal =
          STATUS_RANK[(b?.meetingStatus?.status || "").toLowerCase()] ?? 999; // ← use b
        break;
      }

      case "title": {
        aVal = (a?.title || "").toLowerCase();
        bVal = (b?.title || "").toLowerCase();
        break;
      }

      case "date": {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
        break;
      }

      // default: leave aVal / bVal as‑is for simple fields
    }

    if (aVal < bVal) return order === "asc" ? -1 : 1;
    if (aVal > bVal) return order === "asc" ? 1 : -1;
    return 0;
  });

  const camefromPreviousPage = location.state?.camefromPreviousPage || false;
  useEffect(() => {
    if (authData?.isLogInByChangeOrgSuccess) {
      //  alert("in reload meetinglist")
      navigate(0);
      // dispatch(resetStates())
    }
  }, [authData?.isLogInByChangeOrgSuccess]);

  const fetchMeetingsForUser = (overrideSearchKey) => {
    const payload = {
      page: 1,
      order: searchData.order,
      limit: searchData.limit,
      organizationId: userData.organizationId,
      meetingStatus: searchData.filterData?.meetingStatus,
      meetingType: searchData.filterData?.meetingType,
      toDate: searchData.filterData?.toDate,
      fromDate: searchData.filterData?.fromDate,
      attendeeId: searchData.filterData?.attendeeId,
      createdById: employeeData?.userData?._id,
      accessToken,
    };

    const key = overrideSearchKey ?? searchData.searchKey;
    if (key?.trim()) {
      if (!regularExpressionForSearch.test(key)) {
        setErrors({ searchKey: constantMessages.titleRegexError });
        return;
      }
      payload.searchKey = key;
    }

    setErrors({});
    dispatch(fetchMeetingList(payload));
  };

  // const setUser = () => {
  //   setQuery("");
  //   setDebouncedQuery("");
  //   setShowUserData(true);
  //   setIsMyTasks(true);
  //   setTaskViewClicked(true);
  //   const filters = {
  //     organizationId: userData?.organizationId,
  //     assignedUserId: userData?._id,
  //   };

  //   const updatedSearchData = {
  //     searchKey: "",
  //     limit: 5,
  //     order: -1,
  //     filterData: {},
  //     page: 1,
  //   };

  //   setFilterPayload(filters);
  //   setSearchData(updatedSearchData);

  //   const payload = {
  //     ...filters,
  //     page: 1,
  //     limit: 5,
  //     order: -1,
  //   };

  //   dispatch(fetchActionListNew(payload, accessToken));
  // };

  // const setAll = () => {
  //   setQuery("");
  //   setDebouncedQuery("");
  //   setShowUserData(false);
  //   setIsMyTasks(false);
  //   setTaskViewClicked(true);
  //   const filters = {
  //     organizationId: userData?.organizationId,
  //   };

  //   setFilterPayload(filters);

  //   const payload = {
  //     ...filters,
  //     page: 1,
  //     limit: 5,
  //     order: -1,
  //   };

  //   dispatch(fetchActionListNew(payload, accessToken));
  // };

  const setUser = () => {
    setShowUserData(true);
    const updatedSearchData = {
      searchKey: "",
      limit: 5,
      order: -1,
      page: 1,
      filterData: {},
    };
    setCreatedById(employeeData?.userData?._id);
    dispatch(setCreatedByIdForMeeting(employeeData?.userData?._id))
    //  setFilterPayload(filters);
    setSearchData(updatedSearchData);
    //  fetchMeetingsForUser("");
  };

  const setAll = () => {
    setQuery("");
    setDebouncedQuery("");
    setShowUserData(false);
    setCreatedById(null);
      dispatch(setCreatedByIdForMeeting(null))
    const updatedSearchData = {
      searchKey: "",
      limit: 5,
      order: -1,
      filterData: {},
      page: 1,
    };

    //  setFilterPayload(filters);
    setSearchData(updatedSearchData);
    //  fetchMeetings("");
  };

  return (
    <>
      {!accessToken ? <Navigate to="/login" /> : null}
      <div className="main-content">
        <div className="meeting-page ">
          <div className="meeting-header-text line-height-h4">
            <div>
              <h4>Meetings</h4>
            </div>
          </div>

          <Suspense fallback={<div></div>}>
            <FilterComponent
              setfilter={setfilter}
              filterData={filterData}
              initData={searchData.filterData}
              filter={filter}
            />
          </Suspense>
        </div>
        {/* PRATISHRUTI ADD CODE HERE */}
        <AddButton />
        {/* PRATISHRUTI ADD CODE HERE */}
        <div className="color-box-resp">
          <div className="row mt-3">
            <div className="col-xl-3 col-md-3 col-sm-6 col-6">
              <div className="panel-db panel to-cyan-400 d-flex justify-content-between">
                <div className="flex justify-between">
                  <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold font-size-15 ">
                    Total Meetings
                  </div>
                </div>
                <div className="flex items-center mt-3">
                  <div className="text-3xl font-bold ">
                    {meetingData?.meetingStatisticsData &&
                    !meetingData.statisticLoading
                      ? meetingData?.meetingStatisticsData?.totalMeetings
                      : 0}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-3 col-sm-6 col-6">
              <div className="panel-db panel to-violet-400 d-flex justify-content-between">
                <div className="flex justify-between">
                  <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold font-size-15">
                    Upcoming Meetings
                  </div>
                </div>
                <div className="flex items-center mt-3">
                  <div className="text-3xl font-bold ">
                    {meetingData?.meetingStatisticsData &&
                    !meetingData.statisticLoading
                      ? meetingData?.meetingStatisticsData?.upcommingMeetings
                      : 0}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-3 col-sm-6 col-6">
              <div className="panel-db panel to-green-400 d-flex justify-content-between">
                <div className="flex justify-between">
                  <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold font-size-15">
                    Closed
                  </div>
                </div>
                <div className="flex items-center mt-3">
                  <div className="text-3xl font-bold ">
                    {meetingData?.meetingStatisticsData &&
                    !meetingData.statisticLoading
                      ? meetingData?.meetingStatisticsData?.totalClosedMeetings
                      : 0}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-3 col-sm-6 col-6">
              <div className="panel-db panel to-fuchsia-400 d-flex justify-content-between">
                <div className="flex justify-between">
                  <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold font-size-15">
                    Cancelled
                  </div>
                </div>
                <div className="flex items-center mt-3">
                  <div className="text-3xl font-bold ">
                    {meetingData?.meetingStatisticsData &&
                    !meetingData.statisticLoading
                      ? meetingData?.meetingStatisticsData
                          ?.totalCancelledMeetings
                      : 0}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <MeetingDetailsPieChart
          data={meetingData?.meetingList}
          totalCount={totalCount}
          organizationId={userData?.organizationId}
        />

        <div className="mt-2 table-box responsive-table meeting-list-table1 resp-height100 resp-mt-2 meeting-list-margin-top">
          <div className="d-flex align-items-center justify-content-between resp-flex-column mb-2">
            <div className="left-tbl-text">
              {totalCount > 0 ? (
                <p>
                  Showing {fromDataCount} to {toDataCount} of {totalCount}{" "}
                  entries
                </p>
              ) : null}
            </div>

            <div className="meeting-f-search">
              <div>
                <div className="search-box">
                  <input
                    type="search"
                    placeholder="Search By Meeting Title / ID / Organiser Name"
                    onChange={handleChange}
                    name="query"
                    value={query}
                    autoComplete="off"
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="#4F2CC8"
                    className="bi bi-search"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                  </svg>
                </div>
                {errors?.searchKey && (
                  <span className="error-message">{errors?.searchKey}</span>
                )}
              </div>

              <div>
                <button
                  className="btn add-btn Mom-btn d-flex align-items-center justify-content-center filter-height"
                  id="open-form-btn"
                  onClick={(e) => setfilter(true)}
                >
                  <p> Filter</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-funnel filter-svg"
                    viewBox="0 0 16 16"
                  >
                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div className="graph-btn d-flex align-items-center ">
            <button
              onClick={setAll}
              className={`badge bg-opacity-10 me-2 all-btn padding-btnall ${
                showUserData ? "disable-btn" : "newbtn-color"
              }`}
            >
              All Meetings
            </button>

            <button
              onClick={setUser}
              className={`badge bg-opacity-10 me-2 all-btn padding-btn ${
                showUserData ? "newbtn-color" : "disable-btn"
              }`}
            >
              My Meetings
            </button>
          </div>

          {meetingData.loading ? (
            <div
              className="meeting-page"
              style={{ textAlign: "center", paddingTop: 20 }}
            >
              <Loader />
            </div>
          ) : meetingData.meetingList?.length > 0 && meetingData.isSuccess ? (
            <table className="mt-2 table table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col">Sl.No</th>

                  <th scope="col">
                    {" "}
                    Date & Time
                    <TableSortLabel
                      active={orderBy.includes("date")} // show icon if "date" is in the array
                      direction={orderBy === "date" ? order : "asc"} // direction can be static or dynamic
                      hideSortIcon={false} // always show arrow on hover
                      onClick={() => handleSort("date")}
                    />
                  </th>

                  <th scope="col">
                    {" "}
                    Title & ID
                    <TableSortLabel
                      active={orderBy.includes("title")}
                      direction={orderBy === "title" ? order : "asc"}
                      hideSortIcon={false}
                      onClick={() => handleSort("title")}
                    />
                  </th>
                  <th scope="col">Attendee(s)</th>
                  <th scope="col">RSVP Confirmation</th>

                  <th scope="col" className="text-align-center">
                    {" "}
                    Status
                    <TableSortLabel
                      active={orderBy.includes("status")}
                      direction={orderBy === "status" ? order : "asc"}
                      hideSortIcon={false}
                      onClick={() => handleSort("status")}
                    />
                  </th>
                  <th scope="col" className="text-align-center">
                    Action Due
                  </th>
                  {screenSize <= 768 ? null : (
                    <th scope="col" className="action-col">
                      Actions
                    </th>
                  )}
                </tr>
              </thead>

              <tbody>
                {sortedMeetings.map((meeting, index) => {
                  return (
                    <tr>
                      <td
                        data-label="Sl.No"
                        className="meeting-td-width-9 text-align-center blue-bold-text"
                      >
                        {searchData.limit * (searchData?.page - 1) + index + 1}

                        {screenSize <= 768 ? (
                          <div className="d-inline-block menu-dropdown custom-dropdown inner1-drp">
                            <Dropdown>
                              <MeetingDropDown
                                meetingDetails={meeting}
                                meetingId={meeting._id}
                                status={meeting.meetingStatus?.status}
                                handleCancelModal={(meetingId) => {
                                  handleCancelModal(meeting._id);
                                }}
                                handleResendMeetingDetailsModal={() => {
                                  handleResendMeetingDetailsModal(meeting);
                                }}
                                handleRescheduleModal={() => {
                                  handleRescheduleModal(meeting);
                                }}
                                handleCloseModal={() => {
                                  handleCloseModal(meeting._id);
                                }}
                                handleDeleteModal={(meetingId) => {
                                  handleDeleteModal(meeting._id);
                                }}
                              />
                            </Dropdown>
                          </div>
                        ) : null}
                      </td>
                      <td
                        data-label="Meeting Date & Time"
                        className="meeting-td-width-1 "
                      >
                        {meeting?.date}
                        <p className="detail-date-time">{meeting?.fromTime}</p>
                      </td>
                      {screenSize <= 768 ? (
                        <>
                          {meeting.title?.length > 35 ? (
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement={
                                meetingData.meetingList?.length === 1
                                  ? "top"
                                  : "top"
                              }
                              overlay={popoverHoverFocus(meeting.title)}
                            >
                              <td
                                data-label="Meeting Title"
                                className="meeting-td-width-2 word-break line-break"
                              >
                                <Link
                                  to={`/view-meeting-details/${meeting?._id}`}
                                  state={{ camefromPreviousPage: true }}
                                  style={{
                                    textDecoration: "none",
                                    color: "black",
                                  }}
                                >
                                  <span>{`${meeting.title.slice(
                                    0,
                                    35
                                  )}....`}</span>
                                </Link>

                                <p className="detail-date-time mt-7">
                                  Meeting ID - {meeting?.meetingId}
                                </p>
                                 {meeting?.isRescheduled ? (
                          
                            <Badge bg="secondary" className="reschedule-mr-5">Rescheduled</Badge>
                          
                        ) : null}

                                {meeting?.isFollowOnMeetingAvailable ? (
                                  <Link
                                    to={`/create-followon/${meeting?._id}`}
                                    state={{
                                      meetingId: meeting?._id,
                                      camefromPreviousPage: true,
                                    }}
                                    style={{
                                      textDecoration: "none",
                                      color: "black",
                                    }}
                                  >
                                    <Badge
                                      bg=""
                                      className="badge-light-blue"
                                      state={{ camefromPreviousPage: true }}
                                    >
                                      Follow-On (
                                      {/* {meeting?.followOnMeetings?.length}) */}
                                        {meeting?.followOnMeetingCount})
                                    </Badge>
                                  </Link>
                                ) : null}
                                {meeting?.isActive === false ? (
                                  <p className="badge canceled-color bg-opacity-10 deleted-icon">
                                    Deleted
                                  </p>
                                ) : (
                                  <p></p>
                                )}
                                {meeting.attendees?.length !== 0 &&
                                meeting.attendees?.find(
                                  (item) =>
                                    item?._id?.toString() ===
                                    employeeData?.userData?._id?.toString()
                                ) &&
                                meeting?.canUpdateRSVP === true &&
                                (meeting?.meetingStatus?.status ===
                                  "scheduled" ||
                                  meeting?.meetingStatus?.status ===
                                    "rescheduled") ? (
                                  <div className="respond-button">
                                    {meeting.rsvp === "YES" ? (
                                      <button
                                        disabled
                                        className="respond-action"
                                      >
                                        {" "}
                                        <>&#x2713; </>Yes
                                      </button>
                                    ) : (
                                      <button
                                        className="respond-action"
                                        onClick={() => {
                                          if (!authData.isInValidUser) {
                                            dispatch(
                                              updateRsvp(
                                                "YES",
                                                meeting._id,
                                                accessToken
                                              )
                                            );
                                          }
                                        }}
                                      >
                                        {" "}
                                        Yes
                                      </button>
                                    )}
                                    {meeting.rsvp === "NO" ? (
                                      <button
                                        disabled
                                        className="respond-action"
                                      >
                                        {" "}
                                        <>&#x2713; </>No
                                      </button>
                                    ) : (
                                      <button
                                        className="respond-action"
                                        onClick={() => {
                                          if (!authData.isInValidUser) {
                                            dispatch(
                                              updateRsvp(
                                                "NO",
                                                meeting._id,
                                                accessToken
                                              )
                                            );
                                          }
                                        }}
                                      >
                                        {" "}
                                        No
                                      </button>
                                    )}
                                    {meeting.rsvp === "MAYBE" ? (
                                      <button
                                        disabled
                                        className="respond-action"
                                      >
                                        {" "}
                                        <>&#x2713; </>May Be
                                      </button>
                                    ) : (
                                      <button
                                        className="respond-action"
                                        onClick={() => {
                                          if (!authData.isInValidUser) {
                                            dispatch(
                                              updateRsvp(
                                                "MAYBE",
                                                meeting._id,
                                                accessToken
                                              )
                                            );
                                          }
                                        }}
                                      >
                                        {" "}
                                        May Be
                                      </button>
                                    )}
                                  </div>
                                ) : null}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              data-label="Meeting Title"
                              className="meeting-td-width-2 word-break line-break"
                            >
                              <Link
                                to={`/view-meeting-details/${meeting?._id}`}
                                state={{ camefromPreviousPage: true }}
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                              >
                                <span>{meeting.title}</span>
                              </Link>

                              <p className="detail-date-time mt-7">
                                Meeting ID - {meeting?.meetingId}
                              </p>
                                  
                                 {meeting?.isRescheduled ? (
                         
                            <Badge bg="secondary" className="testing2 reschedule-mr-5">Rescheduled</Badge>
                          
                        ) : null}
                              {meeting?.isFollowOnMeetingAvailable ? (
                                <Link
                                  to={`/create-followon/${meeting?._id}`}
                                  state={{
                                    meetingId: meeting?._id,
                                    camefromPreviousPage: true,
                                  }}
                                  style={{
                                    textDecoration: "none",
                                    color: "black",
                                  }}
                                >
                                  <Badge bg="" className="badge-light-blue">
                                    Follow-On (
                                    
                                     {/* {meeting?.followOnMeetings?.length}) */}
                                        {meeting?.followOnMeetingCount})
                                  </Badge>
                                </Link>
                              ) : null}

                              {meeting?.isActive === false ? (
                                <p className="badge canceled-color bg-opacity-10 deleted-icon">
                                  Deleted
                                </p>
                              ) : (
                                <p></p>
                              )}
                              {meeting.attendees?.length !== 0 &&
                              meeting.attendees?.find(
                                (item) =>
                                  item?._id?.toString() ===
                                  employeeData?.userData?._id?.toString()
                              ) &&
                              meeting?.canUpdateRSVP === true &&
                              (meeting?.meetingStatus?.status === "scheduled" ||
                                meeting?.meetingStatus?.status ===
                                  "rescheduled") ? (
                                <div className="respond-button">
                                  {meeting.rsvp === "YES" ? (
                                    <button disabled className="respond-action">
                                      {" "}
                                      <>&#x2713; </>Yes
                                    </button>
                                  ) : (
                                    <button
                                      className="respond-action"
                                      onClick={() => {
                                        if (!authData.isInValidUser) {
                                          dispatch(
                                            updateRsvp(
                                              "YES",
                                              meeting._id,
                                              accessToken
                                            )
                                          );
                                        }
                                      }}
                                    >
                                      {" "}
                                      Yes
                                    </button>
                                  )}
                                  {meeting.rsvp === "NO" ? (
                                    <button disabled className="respond-action">
                                      {" "}
                                      <>&#x2713; </>No
                                    </button>
                                  ) : (
                                    <button
                                      className="respond-action"
                                      onClick={() => {
                                        if (!authData.isInValidUser) {
                                          dispatch(
                                            updateRsvp(
                                              "NO",
                                              meeting._id,
                                              accessToken
                                            )
                                          );
                                        }
                                      }}
                                    >
                                      {" "}
                                      No
                                    </button>
                                  )}
                                  {meeting.rsvp === "MAYBE" ? (
                                    <button disabled className="respond-action">
                                      {" "}
                                      <>&#x2713; </>May Be
                                    </button>
                                  ) : (
                                    <button
                                      className="respond-action"
                                      onClick={() => {
                                        if (!authData.isInValidUser) {
                                          dispatch(
                                            updateRsvp(
                                              "MAYBE",
                                              meeting._id,
                                              accessToken
                                            )
                                          );
                                        }
                                      }}
                                    >
                                      {" "}
                                      May Be
                                    </button>
                                  )}
                                </div>
                              ) : null}
                            </td>
                          )}
                        </>
                      ) : (
                        <>
                          {meeting.title?.length > 35 ? (
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement={
                                meetingData.meetingList?.length === 1
                                  ? "top"
                                  : "top"
                              }
                              overlay={popoverHoverFocus(meeting.title)}
                            >
                              <td
                                data-label="Meeting Title"
                                className="meeting-td-width-2 word-break line-break"
                              >
                                <Link
                                  to={`/view-meeting-details/${meeting?._id}`}
                                  state={{ camefromPreviousPage: true }}
                                  style={{
                                    textDecoration: "none",
                                    color: "black",
                                  }}
                                >
                                  <span>{`${meeting.title.slice(
                                    0,
                                    35
                                  )}....`}</span>
                                </Link>

                                <p className="detail-date-time mt-7">
                                  Meeting ID - {meeting?.meetingId}
                                    </p>
                           
 {meeting?.rescheduledForMeetingDetails && meeting?.rescheduledForMeetingDetails?.length!==0 && meeting?.rescheduledForMeetingDetails?.map(
                            (meetings, index) => {
                              return (
                                <Link
                                  target={"_blank"}
                                  to={`/view-meeting-details/${meetings?._id}`}
                                  style={{
                                    textDecoration: "none",
                                    color: "black",
                                  }}
                                >
                        
                                    <Badge bg="secondary" className="reschedule-mr-5">Rescheduled</Badge>
                                </Link>
                              );
                            }
                          )}
                                {meeting?.isFollowOnMeetingAvailable ? (
                                  <Link
                                    to={`/create-followon/${meeting?._id}`}
                                    state={{
                                      meetingId: meeting?._id,
                                      camefromPreviousPage: true,
                                    }}
                                    style={{
                                      textDecoration: "none",
                                      color: "black",
                                    }}
                                  >
                                    <Badge
                                      bg=""
                                      className="badge-light-blue"
                                      state={{ camefromPreviousPage: true }}
                                    >
                                      Follow-On (
                                      {/* {meeting?.followOnMeetings?.length}) */}
                                        {meeting?.followOnMeetingCount})
                                    </Badge>
                                  </Link>
                                ) : null}
                                {meeting?.isActive === false ? (
                                  <p className="badge canceled-color bg-opacity-10 deleted-icon">
                                    Deleted
                                  </p>
                                ) : (
                                  <p></p>
                                )}
                                {meeting.attendees?.length !== 0 &&
                                meeting.attendees?.find(
                                  (item) =>
                                    item?._id?.toString() ===
                                    employeeData?.userData?._id?.toString()
                                ) &&
                                meeting?.canUpdateRSVP === true &&
                                (meeting?.meetingStatus?.status ===
                                  "scheduled" ||
                                  meeting?.meetingStatus?.status ===
                                    "rescheduled") ? (
                                  <div className="respond-button">
                                    {meeting.rsvp === "YES" ? (
                                      <button
                                        disabled
                                        className="respond-action"
                                      >
                                        {" "}
                                        <>&#x2713; </>Yes
                                      </button>
                                    ) : (
                                      <button
                                        className="respond-action"
                                        onClick={() => {
                                          if (!authData.isInValidUser) {
                                            dispatch(
                                              updateRsvp(
                                                "YES",
                                                meeting._id,
                                                accessToken
                                              )
                                            );
                                          }
                                        }}
                                      >
                                        {" "}
                                        Yes
                                      </button>
                                    )}
                                    {meeting.rsvp === "NO" ? (
                                      <button
                                        disabled
                                        className="respond-action"
                                      >
                                        {" "}
                                        <>&#x2713; </>No
                                      </button>
                                    ) : (
                                      <button
                                        className="respond-action"
                                        onClick={() => {
                                          if (!authData.isInValidUser) {
                                            dispatch(
                                              updateRsvp(
                                                "NO",
                                                meeting._id,
                                                accessToken
                                              )
                                            );
                                          }
                                        }}
                                      >
                                        {" "}
                                        No
                                      </button>
                                    )}
                                    {meeting.rsvp === "MAYBE" ? (
                                      <button
                                        disabled
                                        className="respond-action"
                                      >
                                        {" "}
                                        <>&#x2713; </>May Be
                                      </button>
                                    ) : (
                                      <button
                                        className="respond-action"
                                        onClick={() => {
                                          if (!authData.isInValidUser) {
                                            dispatch(
                                              updateRsvp(
                                                "MAYBE",
                                                meeting._id,
                                                accessToken
                                              )
                                            );
                                          }
                                        }}
                                      >
                                        {" "}
                                        May Be
                                      </button>
                                    )}
                                  </div>
                                ) : null}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              data-label="Meeting Title"
                              className="meeting-td-width-2 word-break line-break"
                            >
                              <Link
                                to={`/view-meeting-details/${meeting?._id}`}
                                state={{ camefromPreviousPage: true }}
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                              >
                                <span>{meeting.title}</span>
                              </Link>

                              <p className="detail-date-time mt-7">
                                Meeting ID - {meeting?.meetingId}
                                  </p>


     {meeting?.rescheduledForMeetingDetails && meeting?.rescheduledForMeetingDetails?.length!==0 && meeting?.rescheduledForMeetingDetails?.map(
                            (meetings, index) => {
                              return (
                                <Link
                                  target={"_blank"}
                                  to={`/view-meeting-details/${meetings?._id}`}
                                  style={{
                                    textDecoration: "none",
                                    color: "black",
                                  }}
                                >
                 
                                    <Badge bg="secondary" className="testing">Rescheduled</Badge>
                                </Link>
                              );
                            }
                          )}
                                  
                              
                              {meeting?.isFollowOnMeetingAvailable ? (
                                <Link
                                  to={`/create-followon/${meeting?._id}`}
                                  state={{
                                    meetingId: meeting?._id,
                                    camefromPreviousPage: true,
                                  }}
                                  style={{
                                    textDecoration: "none",
                                    color: "black",
                                  }}
                                >
                                  <Badge bg="" className="badge-light-blue">
                                    Follow-On (
                                   {/* {meeting?.followOnMeetings?.length}) */}
                                        {meeting?.followOnMeetingCount})
                                  </Badge>
                                </Link>
                              ) : null}

                              {meeting?.isActive === false ? (
                                <p className="badge canceled-color bg-opacity-10 deleted-icon">
                                  Deleted
                                </p>
                              ) : (
                                <p></p>
                              )}
                              {meeting.attendees?.length !== 0 &&
                              meeting.attendees?.find(
                                (item) =>
                                  item?._id?.toString() ===
                                  employeeData?.userData?._id?.toString()
                              ) &&
                              meeting?.canUpdateRSVP === true &&
                              (meeting?.meetingStatus?.status === "scheduled" ||
                                meeting?.meetingStatus?.status ===
                                  "rescheduled") ? (
                                <div className="respond-button">
                                  {meeting.rsvp === "YES" ? (
                                    <button disabled className="respond-action">
                                      {" "}
                                      <>&#x2713; </>Yes
                                    </button>
                                  ) : (
                                    <button
                                      className="respond-action"
                                      onClick={() => {
                                        if (!authData.isInValidUser) {
                                          dispatch(
                                            updateRsvp(
                                              "YES",
                                              meeting._id,
                                              accessToken
                                            )
                                          );
                                        }
                                      }}
                                    >
                                      {" "}
                                      Yes
                                    </button>
                                  )}
                                  {meeting.rsvp === "NO" ? (
                                    <button disabled className="respond-action">
                                      {" "}
                                      <>&#x2713; </>No
                                    </button>
                                  ) : (
                                    <button
                                      className="respond-action"
                                      onClick={() => {
                                        if (!authData.isInValidUser) {
                                          dispatch(
                                            updateRsvp(
                                              "NO",
                                              meeting._id,
                                              accessToken
                                            )
                                          );
                                        }
                                      }}
                                    >
                                      {" "}
                                      No
                                    </button>
                                  )}
                                  {meeting.rsvp === "MAYBE" ? (
                                    <button disabled className="respond-action">
                                      {" "}
                                      <>&#x2713; </>May Be
                                    </button>
                                  ) : (
                                    <button
                                      className="respond-action"
                                      onClick={() => {
                                        if (!authData.isInValidUser) {
                                          dispatch(
                                            updateRsvp(
                                              "MAYBE",
                                              meeting._id,
                                              accessToken
                                            )
                                          );
                                        }
                                      }}
                                    >
                                      {" "}
                                      May Be
                                    </button>
                                  )}
                                </div>
                              ) : null}
                            </td>
                          )}
                        </>
                      )}
                      <td
                        data-label="Attendees"
                        className="cursor-pointer minHeight-for-noData text-center"
                        onClick={(e) => {
                          setModalStatus(true, meeting);
                        }}
                      >
                        <div className="attendees meeting-list-bg-transparent details-form">
                          {meeting?.attendees &&
                            meeting?.attendees
                              .filter((item, index) => index < 5)
                              .map((attendee, index) => {
                                return (
                                  <OverlayTrigger
                                    key={attendee?._id}
                                    placement="top"
                                    overlay={tooltip(attendee)}
                                    trigger={["hover", "focus"]}
                                  >
                                    <div
                                      className={`attendee-list attendee-list-circle${
                                        meeting?.createdById?.toString() ===
                                        attendee?._id.toString()
                                          ? " attendees-border"
                                          : ""
                                      }`}
                                      style={{
                                        backgroundColor:
                                          attendee?.profilePicture
                                            ? undefined
                                            : getColorFromId(attendee?._id),
                                      
                                      }}
                                    >
                                      {attendee?.profilePicture ? (
                                        <img
                                          src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                                          alt=""
                                          className="attendee-profile-picture icon-image profile-picture attendee-list-circle-img"
                                          style={{
                                         
                                          }}
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.style.display = "none";
                                     
                                            e.target.parentElement.style.backgroundColor =
                                              getColorFromId(attendee?._id);
                                            e.target.parentElement.innerText =
                                              customName(attendee?.name);
                                          }}
                                        />
                                      ) : (
                                        <span className="attendee-name">
                                          {customName(attendee?.name)}
                                        </span>
                                      )}
                                    </div>
                                  </OverlayTrigger>
                                );
                              })}
                        </div>
                        <p className="plus-more-text m-0">
                          {meeting?.attendees?.length > 5
                            ? `+${meeting?.attendees?.length - 5} More`
                            : null}
                        </p>
                      </td>
                      <td
                        className="meeting-td-width meeting-td-width-4"
                        data-label="RSVP Confirmation"
                        onClick={(e) => {
                          setRsvpModalStatus(
                            true,
                            meeting?.attendees,
                            checkRsvpCount(meeting?.attendees)
                          );
                        }}
                      >
                        <p>{meeting?.attendees?.length} Attendees</p>
                        <p className="detail-date-time">
                          {checkRsvpCount(meeting?.attendees)}
                        </p>
                      </td>
                      <td
                        data-label="Status"
                        className="meeting-td-width-5  text-align-center"
                      >
                        <span
                          className={
                            meeting?.meetingStatus?.status === "scheduled"
                              ? "badge  bg-opacity-10 scheduled-color"
                              : meeting?.meetingStatus?.status === "rescheduled"
                                ? "badge  bg-opacity-10 rescheduled-color"
                                : meeting?.meetingStatus?.status === "closed"
                                  ? "badge  bg-opacity-10 closed-color"
                                  : meeting?.meetingStatus?.status === "draft"
                                    ? "badge  bg-opacity-10 draft-color"
                                    : "badge  bg-opacity-10 canceled-color"
                          }
                        >
                          {meeting?.meetingStatus?.status
                            .charAt(0)
                            .toUpperCase() +
                            meeting?.meetingStatus?.status?.slice(1)}
                        </span>
                      </td>
                      <td
                        data-label="Action Due"
                        className="meeting-td-width-6 text-align-center"
                      >
                        {
                          meeting?.actionDetail.filter(
                            (item) => item?.isComplete
                          ).length
                        }
                        /
                        {
                          meeting?.actionDetail?.filter(
                            (item) => item?.isAction
                          ).length
                        }
                      </td>
                      {screenSize <= 768 ? null : (
                        <td
                          data-label="Action"
                          className="text-align-center meeting-td-width-7"
                        >
                          <div className="d-inline-block menu-dropdown custom-dropdown">
                            <Dropdown>
                              <MeetingDropDown
                                meetingDetails={meeting}
                                meetingId={meeting._id}
                                status={meeting.meetingStatus?.status}
                                handleCancelModal={(meetingId) => {
                                  handleCancelModal(meeting._id);
                                }}
                                handleResendMeetingDetailsModal={() => {
                                  handleResendMeetingDetailsModal(meeting);
                                }}
                                handleRescheduleModal={() => {
                                  handleRescheduleModal(meeting);
                                }}
                                handleCloseModal={() => {
                                  handleCloseModal(meeting._id);
                                }}
                                handleDeleteModal={(meetingId) => {
                                  handleDeleteModal(meeting._id);
                                }}
                              />
                            </Dropdown>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })}

                <AttendeesModal
                  IsModalOpen={isModalOpen}
                  attendees={attendeesData}
                  setIsModalOpen={setIsModalOpen}
                  loginUserData={loginUserData}
                  isShow={true}
                  meetingData={meetingDetails}
                  closeMomPermissionModalClose={closeMomPermissionModalClose}
                />
                <AttendeesRsvpModal
                  IsRsvpModalOpen={isRsvpModalOpen}
                  attendees={attendeesData}
                  setIsRsvpModalOpen={setIsRsvpModalOpen}
                  loginUserData={loginUserData}
                  rsvpCount={rsvpCount}
                />
              </tbody>
            </table>
          ) : (
            <div className="no-data-img mt-3">
              <Alert
                status={"info"}
                message={"No data available."}
                timeoutSeconds={0}
              />

              <NoDataFound dataType={"meeting"} />
              {Object.keys(searchData?.filterData)?.length !== 0 ||
              searchData?.searchKey !== "" ? (
                <Button
                  className="mt-2"
                  variant="primary"
                  onClick={(e) => {
                    setSearchData({
                      ...searchData,
                      searchKey: "",
                      filterData: {},
                      page: 1,
                    });
                  }}
                >
                  Clear
                </Button>
              ) : null}
            </div>
          )}
          {totalCount <= 1 ? null : (
            <div className="tbl-bottom">
              <div className="left-tbl-bottom">
                {searchData.page !== 1 ? (
                  <button
                    className="left-arrow"
                    onClick={(e) =>
                      setSearchData({
                        ...searchData,
                        page: searchData.page - 1,
                      })
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#fff"
                      className="bi bi-chevron-left"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                      />
                    </svg>
                  </button>
                ) : null}

                {/* Pagination Component from MUI without arrows */}
                <Stack spacing={2}>
                  <Pagination
                    count={totalPage}
                    page={searchData.page}
                    siblingCount={0}
                    boundaryCount={2}
                    onChange={handlePageChange}
                    hidePrevButton
                    hideNextButton
                    sx={{
                      "& .Mui-selected": {
                        backgroundColor: "#388d27 !important",
                        color: "#fff !important",
                      },
                    }}
                  />
                </Stack>
                {searchData.page !== totalPage && (
                  <button
                    className="right-arrow"
                    onClick={() =>
                      setSearchData({
                        ...searchData,
                        page: searchData.page + 1,
                      })
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#fff"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                      />
                    </svg>
                  </button>
                )}
              </div>

              <div className="right-tbl-bottom">
                <p>Rows Per Page</p>
                <select
                  className="no-opt-box"
                  name="limit"
                  onChange={(e) =>
                    setSearchData({
                      ...searchData,
                      page: 1,
                      limit: e.target.value,
                    })
                  }
                  value={searchData.limit}
                >
                  {totalOption &&
                    Array(totalOption)
                      .fill()
                      .map((_, option) => {
                        return (
                          <option value={(option + 1) * 5}>
                            {(option + 1) * 5}
                          </option>
                        );
                      })}
                </select>
              </div>
            </div>
          )}
        </div>
        {isCancelModalOpen && (
          <CancelMeetingModal
            setIsModalOpen={setIsCancelModalOpen}
            isModalOpen={isCancelModalOpen}
            handleSubmit={handleCancelMeeting}
            isLoading={isLoading}
          />
        )}
        {isDeleteModalOpen && (
          <DeleteMeetingModal
            setIsModalOpen={setIsDeleteModalOpen}
            isModalOpen={isDeleteModalOpen}
            handleSubmit={handleDeleteMeeting}
            isLoading={isLoading}
          />
        )}
        {isCloseModalOpen && (
          <CommonModal
            message={"Do you want to close the meeting ?"}
            title={"Close Meeting"}
            setIsModalOpen={setIsCloseModalOpen}
            isModalOpen={isCloseModalOpen}
            handleSubmit={handleCloseMeeting}
            butto
            nName={"Close"}
          />
        )}
        {isRescheduleModalOpen && (
          <RescheduleMeetingModal
            setIsRescheduleModalOpen={setIsRescheduleModalOpen}
            isRescheduleModalOpen={isRescheduleModalOpen}
            meetingData={singleMeetingDetails}
            isFetchedMeetingList={meetingData.isFetchedMeetingList}
            fetchMeetings={fetchMeetingListForRescheduleData}
            fromMeetingList={true}
          />
        )}

        <ResendMeetingDetailsModal
          isResendMeetingDetailsModalOpen={isResendMeetingDetailsModalOpen}
          setIsResendMeetingDetailsModalOpen={
            setIsResendMeetingDetailsModalOpen
          }
          meetingDetail={singleMeetingDetails}
        />
      </div>
      {/* <Footer /> */}
    </>
  );
});

export default MeetingList;
